import {text_mod_8, } from "../text/Text.js";
export const module08 = {
  title:
    "§8. Зміна значень слова ​зі зміною звука (букви)",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_8, },
    ]
  }
